// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@flip/App/SharedStyle/MyAccount/List/MyAccountFilterSectionStyles";
import { mergeWithCss } from "@flip/XDL/Utilities";
import { rfqMyQuotesFilterStyles } from "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesFilter";
import { css } from "styled-components";

rfqMyQuotesFilterStyles.container = {
    ...mergeWithCss(myAccountFilterSectionStyles.searchFormStyles.wrapper, {
        css: css`
            padding: 20px 25px;
        `,
    }),
};

rfqMyQuotesFilterStyles.heading = {
    ...myAccountFilterSectionStyles.searchFormStyles.headingText,
};

rfqMyQuotesFilterStyles.fromGridItem =
    rfqMyQuotesFilterStyles.toGridItem =
    rfqMyQuotesFilterStyles.expireFromGridItem =
    rfqMyQuotesFilterStyles.expireToGridItem =
        {
            width: [12, 6, 3, 3, 2],
            css: css`
                > div {
                    width: 100%;
                    display: flex;
                    padding-top: 2px;
                }
            `,
        };

rfqMyQuotesFilterStyles.quoteNumberGridItem = {
    width: [12, 12, 6, 3, 2],
};

rfqMyQuotesFilterStyles.clearFiltersButton = {
    variant: "secondary",
    css: css`
        margin-bottom 5px;
    `,
};

rfqMyQuotesFilterStyles.toDate = {
    cssOverrides: {
        inputSelect: css`
            width: 100%;
        `,
    },
};
